import { useEffect, useState } from "react";
import { useInViewOnce } from "@/hooks/useInViewOnce";
import type { BusinessNumber } from "@/types/homepage";

const DURATION = 1400;

/** Counts up to stat.animateTo when first in view; static display otherwise. */
const StatCounter = ({ stat }: { stat: BusinessNumber }) => {
  const { ref, inView } = useInViewOnce<HTMLSpanElement>();
  const [value, setValue] = useState(0);

  useEffect(() => {
    if (!inView || stat.animateTo === undefined) return;

    let raf = 0;
    let start: number | null = null;
    const target = stat.animateTo;

    const step = (ts: number) => {
      if (start === null) start = ts;
      const progress = Math.min((ts - start) / DURATION, 1);
      const eased = 1 - Math.pow(1 - progress, 3); // easeOutCubic
      setValue(Math.round(eased * target));
      if (progress < 1) raf = requestAnimationFrame(step);
    };

    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [inView, stat.animateTo]);

  const display =
    stat.animateTo === undefined
      ? stat.display
      : `${stat.prefix ?? ""}${value}${stat.suffix ?? ""}`;

  return <span ref={ref}>{display}</span>;
};

export default StatCounter;
